import { useEffect, useState } from 'react';

// ═══════════════════════════════════════════════════════════════════════════════
// ONLINE STATUS
//
// `navigator.onLine` is only reliable in one direction: false definitely means
// no network, true means "there is an interface up", which a captive portal
// also satisfies. So this is used to pre-empt a doomed send with an honest
// message, never to claim the connection is healthy.
// ═══════════════════════════════════════════════════════════════════════════════

export function useOnlineStatus() {
    const [online, setOnline] = useState(
        () => (typeof navigator === 'undefined' ? true : navigator.onLine !== false)
    );

    useEffect(() => {
        const up = () => setOnline(true);
        const down = () => setOnline(false);
        window.addEventListener('online', up);
        window.addEventListener('offline', down);
        return () => {
            window.removeEventListener('online', up);
            window.removeEventListener('offline', down);
        };
    }, []);

    return online;
}

export default useOnlineStatus;
